// If the JWT token expires soon, do not use it anymore.
// This is necessary to avoid it being expired
// after the including request reaches the server.
export const MIN_REMAINING_JWT_TTL = 20
